import { HttpClient } from "~/api/HttpClient"
import { BlockContentResponse, StrapiResponse } from "~/types/response"

export const API_PREFIX = "/api/block-contents"

export const useUiBuilder = () => {
  const fetchBlockContent = async (id: string) => {
    return await HttpClient.get<BlockContentResponse>(`/api/block-contents/${id}?populate=*`)
  }

  const saveBlockContent = async (id: string, data: JSON) => {
    return await HttpClient.put(`${API_PREFIX}/${id}`, {
      data: {
        content: JSON.stringify(data),
      },
    })
  }

  const createNewBlockContent = async (data: any): Promise<StrapiResponse<{ id: string }>> => {
    return await HttpClient.post(API_PREFIX, {
      data: {
        content: null,
        ...data,
      },
    })
  }

  const fetchBlockContentTemplate = async () => {
    return await HttpClient.get<BlockContentResponse>(
      `/api/block-contents?populate=*&filters[isTemplate][$eq]=true&pagination[pageSize]=100`,
    )
  }

  type RevalidateType = "pageSlug" | "postSlug" | "categoryId" | string

  const triggerRevalidate = async (typeRevalidate: { name: RevalidateType; value: string }) => {
    const apiTrigger = import.meta.env.VITE_API_TRIGGER_REVALIDATE
    const secretKey = import.meta.env.VITE_API_SECRET_KEY
    const API_PREFIX_REVALIDATE = `${apiTrigger}?secret=${secretKey}&${typeRevalidate.name}=${typeRevalidate.value}`

    return await HttpClient.get(`${API_PREFIX_REVALIDATE}`)
  }

  return {
    fetchBlockContent,
    saveBlockContent,
    createNewBlockContent,
    fetchBlockContentTemplate,
    triggerRevalidate,
  }
}
